import * as React from 'react'

type ToggleSwitchProps = {
  checked: boolean
  onClick: () => void
  activeColor: string
  ariaLabel: string
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onClick,
  activeColor,
  ariaLabel,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      className="relative inline-flex h-[24px] w-[44px] shrink-0 rounded-[10px] transition"
      style={{
        backgroundColor: checked ? activeColor : '#D7DCE8',
      }}
    >
      <span
        className={`absolute top-[2px] h-[20px] w-[20px] rounded-full bg-white transition ${
          checked ? 'left-[22px]' : 'left-[2px]'
        }`}
      />
    </button>
  )
}
